import React from 'react';
import "../css/bootstrap.css"
import "../css/app.css"
import "../css/fas.css"
const img = require("../assets/me3.jpg")
const codechef = require("../assets/codechef-min.png")
const codeforces = require("../assets/codeforces-min.png")

export const About = () => {
    return(
        <div className="container black about">
            <div className="row d-flex justify-content-center">
                <hr className="hr1"></hr>
                <div className="col-lg-6 col-md-12 d-flex flex-column justify-content-center align-items-center aboutme">
                    <h1 className="abouttile">About Me</h1>
                    <p className="aboutp locationp"><i className="fas fa-map-marker-alt"></i>Pondicherry <i className="fas fa-angle-right"></i> Chennai</p>
                    {/* <p className="aboutp summaryp">Electrical Engineering | Coding | Music Lover | Ultimate Frisbee Player</p> */}
                    <p className="aboutp">I am a third year undergraduate, pursuing <span className="special">Dual Degree</span> in <span className="special">Electrical Engineering</span> at <span className="special">IIT Madras</span>. 
                    I am passionate about the design and analysis of algorithms, and love to do <span className="special">competitive coding</span>. 
                    I am also interested in <span className="special">web development</span> and have worked on a few projects. 
                    I am now exploring the field of <span className="special">Machine Learning</span> and working on some basic projects related to it. 
                    Other than that, I enjoy playing <span className="special">Ultimate Frisbee</span> (yes! it's a sport), listening to music and at times, drawing.</p>
                    <div className="row d-flex justify-content-center alllinks">
                        <div className="tabs"><a href="https://github.com/hemanthram" target="_blank" rel="noopener noreferrer"><i className="fab fa-3x fa-github"></i></a></div>
                        <div className="tabs"><a href="https://www.linkedin.com/in/hemanth-ram/" target="_blank" rel="noopener noreferrer"><i className="fab fa-3x fa-linkedin"></i></a></div>
                        <div className="tabs"><a href="https://www.codechef.com/users/hemanthram" target="_blank" rel="noopener noreferrer">
                            <img src={codechef} alt="nothing" height="50px" ></img>
                        </a></div>
                        <div className="tabs"><a href="https://codeforces.com/profile/hemanth_ram" target="_blank" rel="noopener noreferrer">
                            <img src={codeforces} alt="nothing" height="50px" ></img>
                        </a></div>
                    </div>
                    <p className="resumep">For more information, find my resume <a  className="resume" href="/resume.pdf" target="_blank" rel="noopener noreferrer">
                        here<i className="fas fa-file"></i>
                    </a></p>
                </div>
                <div className="col-lg-4 col-md-12 d-flex flex-column justify-content-center align-items-center">
                    <img src={img} alt="nothing" className="meimage"></img>
                </div>
                <hr className="hr1"></hr>
            </div>
        </div>
    )
}